import { render, staticRenderFns } from "./AdminRouterView.vue?vue&type=template&id=87c93362&scoped=true&"
import script from "./AdminRouterView.vue?vue&type=script&lang=js&"
export * from "./AdminRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c93362",
  null
  
)

export default component.exports